import React, { useState, useEffect } from 'react';

// reactstrap components
import {
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
} from "reactstrap";

// services
import apiService from '../../../../service/apiService';
// COMENTADO - Solo usar token de Keycloak, no useToken de TokenContext
// import { useToken } from 'contexts/TokenContext';

function SearchFilters({ filters, onFilterChange, onSearch, onClear, isLoading = false }) {
  const [criteria, setCriteria] = useState([]);
  const [industryOptions, setIndustryOptions] = useState([
    { value: '', label: 'Select Industry' }
  ]);
  const [loadingIndustries, setLoadingIndustries] = useState(false);
  const [industryError, setIndustryError] = useState(null);
  // COMENTADO - Solo usar token de Keycloak, no useToken
  // const { hasToken, isConfigured } = useToken();
  
  // Siempre hay token disponible con Keycloak (si está autenticado)
  const hasToken = () => apiService.hasToken();
  const isConfigured = true;

  // Available fields for search (matching plpgsql procedure fields)
  const fieldOptions = [
    { value: '', label: 'Select Field' },
    { value: 'legalName', label: 'Legal Name' },
    { value: 'dbaName', label: 'DBA Name' },
    { value: 'federalTaxId', label: 'Federal Tax ID' },
    { value: 'stateOfInc', label: 'State of Incorporation' },
    { value: 'industry', label: 'Industry' },
    { value: 'dateEstablished', label: 'Date Established' },
    { value: 'type', label: 'Type' }
    // Note: currentProcessor removed as it's not in plpgsql procedure fields
  ];

  // Available operators
  const operatorOptions = [
    { value: '=', label: 'equals' },
    { value: 'ILIKE', label: 'contains' }
  ];

  // State options for dropdown fields
  const stateOptions = [
    { value: '', label: 'Select State' },
    { value: 'Alabama', label: 'Alabama' },
    { value: 'Alaska', label: 'Alaska' },
    { value: 'Arizona', label: 'Arizona' },
    { value: 'Arkansas', label: 'Arkansas' },
    { value: 'California', label: 'California' },
    { value: 'Colorado', label: 'Colorado' },
    { value: 'Connecticut', label: 'Connecticut' },
    { value: 'Delaware', label: 'Delaware' },
    { value: 'Florida', label: 'Florida' },
    { value: 'Georgia', label: 'Georgia' },
    { value: 'Hawaii', label: 'Hawaii' },
    { value: 'Idaho', label: 'Idaho' },
    { value: 'Illinois', label: 'Illinois' },
    { value: 'Indiana', label: 'Indiana' },
    { value: 'Iowa', label: 'Iowa' },
    { value: 'Kansas', label: 'Kansas' },
    { value: 'Kentucky', label: 'Kentucky' },
    { value: 'Louisiana', label: 'Louisiana' },
    { value: 'Maine', label: 'Maine' },
    { value: 'Maryland', label: 'Maryland' },
    { value: 'Massachusetts', label: 'Massachusetts' },
    { value: 'Michigan', label: 'Michigan' },
    { value: 'Minnesota', label: 'Minnesota' },
    { value: 'Mississippi', label: 'Mississippi' },
    { value: 'Missouri', label: 'Missouri' },
    { value: 'Montana', label: 'Montana' },
    { value: 'Nebraska', label: 'Nebraska' },
    { value: 'Nevada', label: 'Nevada' },
    { value: 'New Hampshire', label: 'New Hampshire' },
    { value: 'New Jersey', label: 'New Jersey' },
    { value: 'New Mexico', label: 'New Mexico' },
    { value: 'New York', label: 'New York' },
    { value: 'North Carolina', label: 'North Carolina' },
    { value: 'North Dakota', label: 'North Dakota' },
    { value: 'Ohio', label: 'Ohio' },
    { value: 'Oklahoma', label: 'Oklahoma' },
    { value: 'Oregon', label: 'Oregon' },
    { value: 'Pennsylvania', label: 'Pennsylvania' },
    { value: 'Rhode Island', label: 'Rhode Island' },
    { value: 'South Carolina', label: 'South Carolina' },
    { value: 'South Dakota', label: 'South Dakota' },
    { value: 'Tennessee', label: 'Tennessee' },
    { value: 'Texas', label: 'Texas' },
    { value: 'Utah', label: 'Utah' },
    { value: 'Vermont', label: 'Vermont' },
    { value: 'Virginia', label: 'Virginia' },
    { value: 'Washington', label: 'Washington' },
    { value: 'West Virginia', label: 'West Virginia' },
    { value: 'Wisconsin', label: 'Wisconsin' },
    { value: 'Wyoming', label: 'Wyoming' }
  ];

  // Type options for merchant type filter
  const typeOptions = [
    { value: '', label: 'Select Type' },
    { value: 'DEALER', label: 'Dealer' },
    { value: 'MONITORING_CENTER', label: 'Monitoring Center' }
  ];

  // Empty fallback for industries (forces API usage)
  const emptyIndustryOptions = [
    { value: '', label: 'Select Industry' }
  ];

  // Note: processorOptions removed as currentProcessor is not in plpgsql procedure fields

  // Load industries from API
  useEffect(() => {
    const loadIndustries = async () => {
      if (!hasToken() || !isConfigured) {
        // Show empty if no token configured (forces user to configure token)
        setIndustryOptions(emptyIndustryOptions);
        setIndustryError('Token required to load industries from API');
        return;
      }

      setLoadingIndustries(true);
      setIndustryError(null);

      try {
        const data = await apiService.getIndustries();
        
        // Transform API response to dropdown options
        if (data && Array.isArray(data)) {
          const options = [
            { value: '', label: 'Select Industry' },
            ...data.map(industry => ({
              value: industry.value || industry.name || industry,
              label: industry.label || industry.name || industry
            }))
          ];
          setIndustryOptions(options);
        } else {
          // Show error if API response is invalid
          console.error('Invalid industries API response structure');
          setIndustryError('Invalid API response structure');
          setIndustryOptions(emptyIndustryOptions);
        }
      } catch (error) {
        console.error('Failed to load industries:', error);
        setIndustryError(error.message);
        // Show empty on error to force fixing the issue
        setIndustryOptions(emptyIndustryOptions);
      } finally {
        setLoadingIndustries(false);
      }
    };

    loadIndustries();
  }, [isConfigured]);

  // Pre-cargar un criterio por defecto cuando se monta el componente
  useEffect(() => {
    if (criteria.length === 0) {
      const newId = `criteria-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      setCriteria([{ id: newId, field: '', operator: 'ILIKE', value: '' }]);
    }
  }, []);


  const addCriteria = () => {
    const newId = `criteria-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    setCriteria(prevCriteria => [...prevCriteria, { id: newId, field: '', operator: 'ILIKE', value: '' }]);
  };

  const removeCriteria = (id) => {
    setCriteria(prevCriteria => prevCriteria.filter(c => c.id !== id));
  };

  const updateCriteria = (id, field, value) => {
    console.log(`🔄 updateCriteria: ${id}, ${field} = "${value}"`);
    setCriteria(prevCriteria => {
      const updated = prevCriteria.map(c => 
        c.id === id ? { ...c, [field]: value } : c
      );
      console.log('📋 Updated criteria:', updated);
      return updated;
    });
  };

  const handleSearch = () => {
    console.log('🚀 handleSearch called');
    console.log('📋 Current criteria:', criteria);
    
    // Validate that we have at least one valid criterion
    const validCriteria = criteria.filter(c => 
      c.field && c.field !== '' && c.value && c.value.trim() !== ''
    );
    
    console.log('✅ Valid criteria found:', validCriteria.length);
    
    if (validCriteria.length === 0) {
      console.log('❌ No valid criteria found - showing all merchants');
      onFilterChange({});
      onSearch();
      return;
    }
    
    // Convert criteria to filters format
    const searchFilters = {};
    
    validCriteria.forEach(c => {
      console.log('🔍 Processing valid criterion:', c);
      
      // Add the main field value
      searchFilters[c.field] = c.value.trim();
      
      // Add the operator for this field
      searchFilters[`${c.field}_operator`] = c.operator;
      
      console.log(`✅ Added filter: ${c.field} = "${c.value.trim()}" (operator: ${c.operator})`);
    });
    
    console.log('🎯 Final searchFilters object:', searchFilters);
    
    // Call the parent handlers
    console.log('📤 Calling onFilterChange with:', searchFilters);
    onFilterChange(searchFilters);
    
    console.log('📤 Calling onSearch with filters:', searchFilters);
    onSearch(searchFilters);
  };

  const handleClear = () => {
    const newId = `criteria-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    setCriteria([{ id: newId, field: '', operator: 'ILIKE', value: '' }]);
    onClear();
  };

  const hasValidCriteria = () => {
    const valid = criteria.some(c => c.field && c.field !== '' && c.value && c.value.trim() !== '');
    console.log('🔍 hasValidCriteria check:', { criteria, valid });
    return valid;
  };



  const getValueInput = (criterion) => {
    const { field, value } = criterion;
    
    switch (field) {
      case 'stateOfInc':
        return (
          <Input
            type="select"
            size="sm"
            value={value}
            onChange={(e) => updateCriteria(criterion.id, 'value', e.target.value)}
          >
            {stateOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        );
      
      case 'industry':
        return (
          <Input
            type="select"
            size="sm"
            value={value}
            onChange={(e) => updateCriteria(criterion.id, 'value', e.target.value)}
          >
            {industryOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        );
      
      case 'type':
        return (
          <Input
            type="select"
            size="sm"
            value={value}
            onChange={(e) => updateCriteria(criterion.id, 'value', e.target.value)}
          >
            {typeOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        );
      
             // Note: currentProcessor case removed as it's not in plpgsql procedure fields
      
      case 'dateEstablished':
        return (
          <Input
            type="date"
            size="sm"
            value={value}
            onChange={(e) => updateCriteria(criterion.id, 'value', e.target.value)}
          />
        );
      case 'federalTaxId':
        return (
          <Input
            type="text"
            size="sm"
            placeholder="XX-XXXXXXX"
            maxLength="10"
            value={value}
            onChange={(e) => {
              const digits = String(e.target.value || '').replace(/\D/g, '').slice(0, 9);
              const masked = digits.length <= 2 ? digits : `${digits.slice(0, 2)}-${digits.slice(2)}`;
              updateCriteria(criterion.id, 'value', masked);
            }}
          />
        );
      
      default:
        return (
          <Input
            type="text"
            size="sm"
            placeholder="Enter value..."
            value={value}
            onChange={(e) => {
              console.log(`🔍 Input change for ${criterion.field}: "${e.target.value}"`);
              updateCriteria(criterion.id, 'value', e.target.value);
            }}
          />
        );
    }
  };

  return (
    <div>
      {/* COMENTADO - Solo usar token de Keycloak, no mostrar alerta de token de Postman */}
      {/* Token Configuration Alert */}
      {/* {!isConfigured && (
        <Alert color="warning" className="mb-2 py-2">
          <small>
            <strong>⚠️ Token Required:</strong> Configure your Postman token in{" "}
            <a href="/api-testing" className="alert-link">API Testing</a> section.
          </small>
        </Alert>
      )} */}

      {/* Industries Loading Error */}
      {industryError && (
        <Alert color="danger" className="mb-2 py-2">
          <small>
            <strong>❌ API Error:</strong> {industryError}
          </small>
        </Alert>
      )}

      {/* Search Criteria Section */}
      <div className="mb-2">
        <div className="d-flex justify-content-between align-items-center mb-1">
          <h6 className="mb-0 text-muted small">
            <i className="ni ni-zoom-split-in mr-1"></i>
            Search Criteria
          </h6>
          <small className="text-muted">
            {loadingIndustries && (
              <span className="text-info">🔄 Loading...</span>
            )}
          </small>
        </div>

        {/* Criteria Rows */}
        {criteria.length === 0 ? (
          <div className="text-center py-2 border rounded bg-light">
            <i className="ni ni-zoom-split-in text-muted" style={{ fontSize: '1rem' }}></i>
            <p className="text-muted mt-1 mb-0 small">All merchants shown by default. Add criteria to filter.</p>
          </div>
        ) : (
          <div className="border rounded bg-light" style={{ maxWidth: '900px' }}>
            {/* Table Headers */}
            <div className="p-2 border-bottom bg-white">
              <Row>
                <Col md="4">
                  <small className="text-muted font-weight-bold">Field</small>
                </Col>
                <Col md="3">
                  <small className="text-muted font-weight-bold">Operator</small>
                </Col>
                <Col md="5">
                  <small className="text-muted font-weight-bold">Value</small>
                </Col>
              </Row>
            </div>
            
            {/* Criteria Rows */}
            <div className="p-2">
              {criteria.map((criterion, index) => (
                <Row key={criterion.id} className={`align-items-end ${index > 0 ? 'mt-1' : ''}`}>
                  <Col md="4">
                    <FormGroup className="mb-0">
                      <Input
                        type="select"
                        size="sm"
                        value={criterion.field}
                        onChange={(e) => updateCriteria(criterion.id, 'field', e.target.value)}
                      >
                        {fieldOptions.map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md="3">
                    <FormGroup className="mb-0">
                      <Input
                        type="select"
                        size="sm"
                        value={criterion.operator}
                        onChange={(e) => updateCriteria(criterion.id, 'operator', e.target.value)}
                      >
                        {operatorOptions.map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md="5">
                    <FormGroup className="mb-0">
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          {getValueInput(criterion)}
                        </div>
                        <Button
                          color="link"
                          size="sm"
                          className="p-0 ml-1"
                          onClick={() => removeCriteria(criterion.id)}
                          title="Remove criteria"
                        >
                          <i className="ni ni-fat-remove text-danger"></i>
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              ))}
            </div>
          </div>
        )}
      </div>

        {/* Add Criteria Button */}
        <div className="mb-2">
          <Button
            color="outline-primary"
            size="sm"
            onClick={addCriteria}
          >
            <i className="ni ni-fat-add mr-1"></i>
            Add Criteria
          </Button>
        </div>

                 {/* Action Buttons */}
         <div className="d-flex justify-content-end">
           <Button
             color="warning"
             className="mr-2"
             onClick={handleClear}
             disabled={!hasValidCriteria()}
           >
             Clear
           </Button>
           <Button
             color="primary"
             onClick={handleSearch}
             disabled={criteria.length === 0 || isLoading || !hasValidCriteria()}
           >
             {isLoading ? 'Searching...' : `Search (${criteria.length} criteria)`}
           </Button>
         </div>
    </div>
  );
}

export default SearchFilters;
